// ISO 128 / ASME Y14.5 drafting standards

export const LINE_STYLES = {
  visible: { strokeWidth: 1.4, dashArray: 'none' },
  hidden: { strokeWidth: 0.7, dashArray: '6,3' },
  centerline: { strokeWidth: 0.5, dashArray: '16,4,3,4' },
  dimension: { strokeWidth: 0.5, dashArray: 'none' },
  extension: { strokeWidth: 0.5, dashArray: 'none' },
  phantom: { strokeWidth: 0.5, dashArray: '16,4,3,4,3,4' },
  border: { strokeWidth: 1.8, dashArray: 'none' },
} as const;

export const SHEET = {
  A3: { w: 420, h: 297 },
  A4: { w: 297, h: 210 },
  A2: { w: 594, h: 420 },
  A1: { w: 841, h: 594 },
  margin: 10,
  innerMargin: 5,
} as const;

export const TITLE_BLOCK = {
  width: 190,
  height: 55,
  fontSize: {
    title: 6,
    label: 2.8,
    value: 3.5,
    company: 5,
  },
} as const;

export type RenderMode = 'interactive' | 'drawing';

export const DIMENSION = {
  arrowLength: 4,
  arrowWidth: 1.5,
  extensionGap: 1.5,
  extensionOvershoot: 2.5,
  offsetFromGeometry: 12,
  stackSpacing: 10,
  fontSize: 4.5,
  pillPadding: { x: 2.5, y: 1.5 },
  leaderLength: 14,
  leaderOffset: 5,
  calloutFontSize: 3.5,
  toleranceFontSize: 2.8,
} as const;

// Colors for the interactive drawing — brand palette only
export const COLORS = {
  line: '#170C79', // indigo lines on white sheet
  dimension: '#56B6C6', // teal accent for dimensions
  dimensionActive: '#170C79', // indigo when active
  text: '#170C79',
  titleBlock: '#170C79',
  background: '#FFFFFF',
  border: '#170C79',
  hatch: 'rgba(23, 12, 121, 0.45)',
} as const;

// Monochrome colors for manufacturing drawing mode (technical-print style — must
// stay legible if printed in B&W, so still use deep indigo / black-equivalent)
export const DRAWING_COLORS = {
  line: '#170C79',
  dimension: '#170C79',
  dimensionActive: '#170C79',
  text: '#170C79',
  titleBlock: '#170C79',
  background: '#FFFFFF',
  border: '#170C79',
  hatch: 'rgba(23, 12, 121, 0.55)',
  label: 'rgba(23, 12, 121, 0.7)',
} as const;
